import Footer from 'components/Footer'
import MobileFooter from 'components/MobileFooter';
import MobileNavbar from 'components/MobileNavbar';
import Navbar from 'components/Navbar'
import PublicationsList from 'components/Publications/PublicationsList';
import React from 'react';
import { useSelector } from 'react-redux';
import { useEffect } from "react";


function Publications() {
  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbar />
      <PublicationsList />
      <MobileFooter />
      </>
    ) : (
      <>
      <Navbar />
      <PublicationsList />
      <Footer />
      </>
    )}
    </>
  )
}

export default Publications